<template>
  <div v-if="filter && loadingFilters"></div>
  <div v-else>
    <v-toolbar
      class="toolbar-element"
      light
      flat
      height="80em"
      v-if="toolbar"
    >
      <template v-if="$vuetify.breakpoint.smAndUp">
        <v-toolbar-title class="toolbar-title">{{
          toolbarTitle
        }}</v-toolbar-title>
        <slot name="toolbar-table"></slot>
        <v-spacer></v-spacer>
      </template>
      <v-flex :xs4="$vuetify.breakpoint.smAndUp" v-if="searchText">
        <v-text-field
          v-model="search"
          solo
          light
          append-icon="search"
          :label="searchText"
          single-line
          hide-details
          flat
        ></v-text-field>
      </v-flex>
    </v-toolbar>
    <div :class="{ 'spacing-top': toolbar }">
      <slot name="before-filters"></slot>
      <v-card-actions class="filter-bar mb-0 pb-0 dates date-filter-bar">
        <v-spacer></v-spacer>
        <template v-if="filter">
          <template v-for="header in getDateHeaders(headers)">
            <DatePickerForm
              class="date-filter"
              v-model="filters[header.value]"
              :label="header.text"
              clearable
              :key="header.text"
            >
            </DatePickerForm>
          </template>
        </template>
      </v-card-actions>
      <v-card-actions class="filter-bar mb-0 pb-0">
        <div class="text-grey mr-2 pt-2 mt-2">{{ totalItems }} resultados</div>
        <v-spacer></v-spacer>
        <template v-if="filter">
          <!--torneo-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="torneo"
            :items="listTorneo"
            label="Torneo"
            item-text="description"
            item-value="id"
            v-on:change="fillFecha"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <!--Fecha-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="fecha"
            :items="listFechaItems"
            label="Fecha"
            item-text="nombreCompleto"
            item-value="id"
            v-on:change="fillPartido"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <!--Partido-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="partido"
            :items="listPartidosItems"
            label="Partido"
            item-text="description"
            item-value="id"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <!--ClubLocal-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="clubLocal"
            :items="listClubItems"
            label="Local"
            item-text="nombre"
            item-value="id"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <!--clubVisitante-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="clubVisitante"
            :items="listClubItems"
            label="Visitante"
            item-text="nombre"
            item-value="id"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <!--status-->
          <v-autocomplete
            flat
            hide-details
            small
            clearable
            outline
            light
            height="30"
            class="filter-element select-element dense-select"
            solo
            dense
            v-model="status"
            :items="listStatus"
            label="Estado"
            item-text="description"
            item-value="value"
            no-data-text="No hay datos disponibles"
          ></v-autocomplete>
          <v-tooltip bottom>
            <v-btn slot="activator" icon @click="submitFiltering" flat>
              <v-icon color="primary">search</v-icon>
            </v-btn>
            <span>Filtrar</span>
          </v-tooltip>
          <slot name="after-filters"></slot>
        </template>
      </v-card-actions>
      <div class="white-box">
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :loading="loading"
          :rows-per-page-items="[10, 25, 50]"
          rows-per-page-text="Ítems por página:"
          class="table-element dense-table-header mt-2"
          hide-actions
          light
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr class="table-header">
              <template v-for="header in props.headers">
                <th
                  :key="header.text"
                  v-if="!(header.hasOwnProperty('visible') && !header.visible)"
                  :class="[
                    'header-title',
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    `text-xs-${header.align}`
                  ]"
                  @click="changeSort(header)"
                >
                  <span class="header-title white--text">{{
                    header.text
                  }}</span>
                  <v-icon
                    color="white"
                    small
                    v-if="
                      !(header.hasOwnProperty('sortable') && !header.sortable)
                    "
                    >arrow_upward</v-icon
                  >
                </th>
              </template>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <slot
              name="first-column"
              :item="props.item"
              v-if="slotName === 'first-column'"
            ></slot>
            <td
              v-for="(property, index) in properties"
              :key="property"
              :class="['table-row', getAlignment(index)]"
            >
              <div :class="['limit-height', 'limit-width', getWidth(index)]">
                {{
                  getFieldValue(props.item, index) || getDefaultValue(property)
                }}
              </div>
            </td>
            <slot
              name="second-last-column"
              :item="props.item"
              v-if="slotName === 'second-last-column'"
            ></slot>
            <td
              v-if="actionButtonsName"
              class="text-xs-right table-row"
              :key="'action'"
            >
              <component :is="actionButtonsName" :item="props.item"></component>
            </td>
          </template>

          <template slot="no-data">
            <div class="text-xs-center" v-if="loading">Cargando datos...</div>
            <div class="text-xs-center" v-else>No hay datos disponibles</div>
          </template>
        </v-data-table>
        <div class="text-xs-right pagination-element">
          <v-pagination
            light
            v-model="pagination.page"
            :length="pages"
            :total-visible="7"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InformeAuditoriaActionButton from '../../features/informes-auditorias/components/InformeAuditoriaActionButton'
import { paginationMixin } from '../../mixins/paginationMixin'
import DatePickerForm from './DatePickerForm'

export default {
  mixins: [paginationMixin],

  props: {
    headers: Array,
    path: String,
    filterPath: String,
    actionButtonsName: String,
    properties: Array,
    filter: Boolean,
    slotName: String,
    toolbar: Boolean,
    toolbarTitle: String,
    searchText: String,
    defaults: {
      type: Object,
      default: () => {
        return {}
      }
    },
    categoryId: {
      type: String
    }
  },
  data () {
    return {
      listTorneo: [],
      torneo: '',
      listFechaItems: [],
      fecha: '',
      listPartidosItems: [],
      partido: '',
      listClubItems: [],
      clubLocal: '',
      clubVisitante: '',
      listStatus: [],
      status: ''
    }
  },

  components: {
    DatePickerForm,
    InformeAuditoriaActionButton
  },

  methods: {
    selectAll (header) {
      let selectedValues = this.filters[header.value]
      let allValues = this.columnValueList(header.value)
        .slice()
        .map(item => item.value)

      if (selectedValues.length === allValues.length) {
        this.filters[header.value] = []
      } else {
        this.filters[header.value] = allValues
      }
      this.$forceUpdate()
    },
    getFieldValue (item, index) {
      let propertyList = this.properties[index].split('.')
      let fieldValue = item
      for (let property of propertyList) {
        if (property) {
          fieldValue = fieldValue[property]
        }
      }
      return fieldValue
    },
    getDefaultValue (property) {
      return this.defaults.hasOwnProperty(property)
        ? this.defaults[property]
        : ''
    },
    getArrayWithoutLastItem (array) {
      return array.slice(0, array.length - 1)
    },
    getDateHeaders (array) {
      let dateHeaders = []
      let headers = this.getArrayWithoutLastItem(array)
      for (var i = 0; i < headers.length; i++) {
        if (headers[i].dateFilterField) {
          dateHeaders.push(headers[i])
        }
      }
      return dateHeaders
    },
    getAlignment (index) {
      let alignment = this.headers[index].align
      return alignment ? `text-xs-${alignment}` : 'text-xs-center'
    },
    getWidth (index) {
      let header = this.headers[index]
      return header.value === 'description' ? 'observation-text' : ''
    },
    fetchTorneoItems () {
      this.loading = true
      let url = 'informe-auditoria/torneos'
      if (this.categoryId) {
        url += `?categoryId=${this.categoryId}`
      }

      this.axios
        .get(url)
        .then(response => {
          this.listTorneo = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fillFecha (event) {
      this.fetchFechasByIdTorneo(event)
    },
    fillPartido (event) {
      this.fetchPartidosByIdFecha(event)
    },
    fetchFechasByIdTorneo (id) {
      this.loading = true
      this.axios
        .get(`informe-auditoria/fechas`, {
          params: {
            torneo: id
          }
        })
        .then(response => {
          this.listFechaItems = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchPartidosByIdFecha (idFecha) {
      this.loading = true
      this.axios
        .get(`informe-auditoria/partidos`, {
          params: {
            fecha: idFecha
          }
        })
        .then(response => {
          this.listPartidosItems = response.data
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    getFilteringPath () {
      let filterPath = ''
      if (this.torneo !== '' && this.torneo !== undefined) {
        filterPath += `&torneo=${this.torneo}`
      }
      if (this.fecha !== '' && this.fecha !== undefined) {
        filterPath += `&fecha=${this.fecha}`
      }
      if (this.partido !== '' && this.partido !== undefined) {
        filterPath += `&partido=${this.partido}`
      }
      if (this.clubLocal !== '' && this.clubLocal !== undefined) {
        filterPath += `&local=${this.clubLocal}`
      }
      if (this.clubVisitante !== '' && this.clubVisitante !== undefined) {
        filterPath += `&visitante=${this.clubVisitante}`
      }
      if (this.status !== '' && this.status !== undefined) {
        filterPath += `&status=${this.status}`
      }
      if (this.categoryId !== '' && this.categoryId !== undefined) {
        filterPath += `&categoryId=${this.categoryId}`
      }

      //  for (let column of Object.keys(this.filters)) {
      // We check if current filter is a set of elements or a date.
      // if (Array.isArray(this.filters[column])) {
      //  filterPath += (this.filters[column].length) ? `&${column}[]=${this.filters[column].join(`&${column}[]=`)}` : ''
      // } else {
      // if (this.filters[column]) {
      // filterPath += `&${column}=${this.filters[column]}`
      // }
      // }
      // }
      // if (this.filter) {
      // this.$store.commit('pagination/setFilters', this.filters)
      // }
      return filterPath
    },
    fetchCLubItems () {
      this.axios

        .get('informe-auditoria/clubes')
        .then(response => {
          this.listClubItems = response.data
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    },
    fetchstatusItems () {
      this.axios

        .get('informe-auditoria/status')
        .then(response => {
          this.listStatus = response.data.items
        })
        .catch(error => {
          this.$store.commit('setErrorMsg', error)
        })
    }
  },
  mounted () {
    this.fetchTorneoItems()
    this.fetchCLubItems()
    this.fetchstatusItems()
    this.fetchData()
  },
  watch: {
    'categoryId' () {
      this.fetchTorneoItems()
      this.fetchCLubItems()
      this.fetchstatusItems()
      this.fetchData()
    }
  }
}
</script>

<style scoped>
.spacing-top {
  margin-top: 0em;
}
.white-box {
  background-color: white;
}
.table-header {
  background-color: #293968;
}
.table-row {
  background-color: white;
  border-bottom: 1px solid #959ba6;
  color: #5f5b5b;
  font-size: 1.05em;
}
.limit-height {
  overflow: hidden;
  max-height: 4.5em;
}
.limit-width {
  overflow: hidden;
  max-width: 40em;
}
.observation-text {
  max-width: 15em;
}
.table-element {
  margin-top: 1em;
  font-family: SourceSansProRegular, sans-serif;
}
.header-title {
  font-size: 1.05em;
}
th.header-title {
  border-bottom: 7.5px solid #0bbad9;
}
.pagination-element {
  margin-top: 2em;
  padding-bottom: 1em;
}
.text-grey {
  color: #5f5b5b;
}
.filter-element {
  font-family: SourceSansProRegular, sans-serif;
  font-size: 1.1em;
  padding-right: 0.5em;
}
.select-element {
  max-width: 20em;
}
.filter-bar {
  margin-bottom: 0.5em;
}
.date-filter-bar {
  margin-right: 7em;
}
.date-filter {
  margin-right: 1em;
  margin-left: 1em;
}
</style>
